export default __webpack_public_path__ + "static/media/down_arrow.de13b23a.svg";